module.exports = __webpack_public_path__ + "img/footer.84ec2f91.webp";